<template>
  <div class="index">
    <navi :activeIndex="0"></navi>
    <div class="block2">
      <img class="b2-img1" src="@/assets/logo_youren.png" alt="游仁科技" />
      <span class="b2-text1">智能驾培系统</span>
      <div class="b2-con2">
        <img class="b2-img2" src="@/assets/icon_tech-01.png" alt="AR技术智能教学" />
        <img class="b2-img2" src="@/assets/icon_tech-02.png" alt="AR技术动作分析" />
        <img class="b2-img2" src="@/assets/icon_tech-03.png" alt="VR技术驾驶视觉仿真" />
        <img class="b2-img2" src="@/assets/icon_tech-04.png" alt="体感技术高精运动仿真" />
      </div>
      <div class="b2-text2">
        经过三年测试，
        <span class="b2-t3-b">&nbsp5000&nbsp</span>样本分析表明，VR新驾培
      </div>
      <div class="b2-text2">
        学车效率更高，可以替代
        <span class="b2-t3-b">&nbsp70%&nbsp</span>场地学车工作量
      </div>
    </div>
    <div class="block3">
      <div class="b3-left">
        <img class="b3-img1" src="@/assets/logo_youren.png" alt="游仁VR" />
        <span class="b2-text1 b3-text2">仿真驾驶引擎</span>
        <div class="b3-text1">1个核心，6大模块</div>
      </div>
      <img class="b3-right" src="@/assets/icon_blue-01.png" alt="1个核心，6大模块" />
    </div>
    <div class="block4">
      <div class="b4-text1">抗眩晕</div>
      <div class="b4-text1">七轴动感学车机</div>
      <div class="b4-con">
        <img src="@/assets/mobile/icon_shebei-01.png" alt="传统设备眩晕率85%" />
        <img src="@/assets/mobile/icon_shebei-02.png" alt="VR设备眩晕率低至3%" />
      </div>
      <div class="b4-text2">核心指标</div>
      <div class="b4-text3">动感轴数：7个</div>
      <div class="b4-text3">帧率保持：稳定120帧</div>
      <div class="b4-text3">定位精度：<1毫米</div>
      <div class="b4-text3">响应速率：1毫秒</div>
      <div class="b4-text3">显示精度：3k</div>
      <img class="b4-right" src="@/assets/mobile/p_03_01-01.png" alt="VR设备" />
    </div>
    <div class="block5">
      <div class="b5-text1">VR驾驶课程场景</div>
      <div class="b5-con1">
        <div class="b5-con3">
          <img src="@/assets/p_04-01.png" alt="高仿真考场环境" />
          <div class="b5-text2">高仿真考场环境</div>
        </div>
        <div class="b5-con3">
          <img src="@/assets/p_04-02.png" alt="模拟真实城市驾驶环境" />
          <div class="b5-text2">模拟真实城市驾驶环境</div>
        </div>
      </div>
      <div class="b5-con2">
        <span class="b5-text3">VR驾驶课程</span>
        <span class="b5-text3">课程涵盖全面·教学智能高效</span>
        <div class="b5-con4">
          <span class="b5-text4">课程全面覆盖科目二、科目三各项基础训练、分项训练和模拟考试</span>
          <span class="b5-text4">独创性的加入了城市驾驶演练内容，还可针对有驾照人士进行上路复训。</span>
        </div>
      </div>
    </div>
    <div class="block6">
      <div class="b6-text1">所获荣誉及公开报道</div>
      <div class="b6-con1">
        <div class="b6-con2">
          <img src="@/assets/p_05-01.png" alt="2017阿里巴巴诸神之战全球创客大赛" />
          <div class="b6-text2">福建省冠军</div>
          <div class="b6-text3">2017阿里巴巴诸神之战全球创客大赛</div>
        </div>
        <div class="b6-con2">
          <img src="@/assets/p_05-02.png" alt="2019《驾培的VR之变》" />
          <div class="b6-text2">《福建日报》报道</div>
          <div class="b6-text3">2019《驾培的VR之变》</div>
        </div>
        <div class="b6-con2">
          <img src="@/assets/p_05-03.png" alt="《福州：当VR驾驶模拟设备走进驾校》" />
          <div class="b6-text2">福建省运输管理局官网报道</div>
          <div class="b6-text3">《福州：当VR驾驶模拟设备走进驾校》</div>
        </div>
        <div class="b6-con2 b6-con3">
          <img src="@/assets/p_05-04.png" alt="亚洲VR&AR金奖·行业贡献奖" />
          <div class="b6-text2">亚洲VR&AR金奖·行业贡献奖</div>
        </div>
      </div>
      <div class="b6-con4">
        <div class="b6-text5">所获荣誉</div>
        <div>2016年 厦门市虚拟与增强现实产业协会 创会理事</div>
        <div>2017年 “白鹭之星”创新创业大赛 二等奖</div>
        <div>2017年 “阿里巴巴神创之战”福建地区 一等奖</div>
        <div>2018年 厦门市创新创业优秀评选 最具潜力创新创业奖</div>
        <div>2019年 金V奖 最佳创新企业奖</div>
        <div>2019年 亚洲VR&AR金奖•VRAR行业贡献奖</div>
        <div class="b6-text5">主流媒体报道</div>
        <div>东南网播报</div>
        <div>海峡网</div>
        <div>福州新闻网</div>
        <div>海西晨报</div>
        <div>……</div>
      </div>
    </div>
    <div class="block7">
      <img class="b7-img0" src="@/assets/logo_youren.png" alt="游仁Logo" />
      <div class="b7-left">
        <!-- <div class="b7-text1">VR驾培新体验</div>
        <input class="b7-input" placeholder="请输入您的名字" v-model="name">
        <input class="b7-input" placeholder="请输入您的电话" v-model="phone">
        <button class="b7-btn" @click="onSignIn">免费预约体验</button>
        <div class="b7-text2">体验点设于福州、厦门、宁德三地</div>-->
        <div class="b7-text1">欢迎加盟合作</div>
        <div class="qn_c">
          <img class="qnimg2" src="@/assets/bt_wenquandiaocha.png" />
          <a class="qn_link" href="/questionnaire"></a>
          <div class="qn_item">
            <img class="qnimg" src="@/assets/icon_wenquandiaocha.png" alt="问卷调查" />
            <div class="questionnaire">填写加盟问卷调查</div>
          </div>
        </div>
      </div>
      <div class="b7-right">
        <div class="b7-text3">联系我们</div>
        <!-- <img class="b7-img1" src="@/assets/logo_youren_black.png" alt="VR驾培">
        <div class="b7-text4">厦门游仁信息科技有限公司</div>
        <div class="b7-text4">厦门市湖里区高新技术园岭下南路77号201</div>-->
        <div class="b7-con2">
          <img class="b7-img2" src="@/assets/p_06-01.png" alt="商务总监二维码" />
          <div class="b7-con">
            <div class="b7-text5">商务总监&nbsp&nbsp&nbsp&nbsp&nbsp吴先生</div>
            <div class="b7-text5">TEL:18060912324</div>
            <div class="b7-text5">微信：wzm448397012</div>
            <div class="b7-text5">EMAIL：michwu@foxmail.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "Index",
  components: {
    Navi
  },
  data() {
    return {
      name: "",
      phone: ""
    };
  },
  created() {
    if (!this.$util.isMobile()) {
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    query(url, params, callback) {
      this.$indicator.open("请求中...");
      this.$axios
        .post(url, params)
        .then(res => {
          this.$indicator.close();
          console.log(res.data);
          if (res.data.err) {
            if (4007 == res.data.err) {
              return this.$toast("该手机号已预约！");
            }
            return this.$toast(res.data.msg);
          }
          callback && callback(res.data.data);
        })
        .catch(e => {
          console.log(e);
          this.$toast("请求失败");
          this.$indicator.close();
        });
    },
    onSignIn() {
      if (!this.$util.validateName(this.name)) {
        this.$toast("请输入正确的姓名");
        return;
      }
      if (!this.$util.validateMobile(this.phone)) {
        this.$toast("请输入正确的手机号码");
        return;
      }

      this.query(
        "/phoneapi/signUp",
        {
          phone: this.phone,
          name: this.name,
          channel: "website"
        },
        data => {
          this.$toast("预约成功！");
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  background-color: rgb(43, 43, 51);
  /* background: url("src/assets/mobile/mobile.png"); */
  background-size: contain;
  /* height: 6000px; */
  color: black;
}

.block2 {
  height: 518px;
  background: url("src/assets/mobile/p_01.jpg");
  padding-top: 350px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.b2-text1 {
  font-size: 26px;
  color: white;
}
.b2-text2 {
  font-size: 10px;
  color: white;
  margin: 10px 70px;
}
.b2-t3-b {
  font-size: 26px;
  color: #ec7f5d;
}
.b2-con2 {
  margin: 60px 70px 0px;
  height: 120px;
}
.b2-img1 {
  text-align: center;
  display: block;
  margin: 39px auto 6px;
  width: 160px;
}
.b2-img2 {
  margin-left: 21px;
  float: left;
  width: 75px;
}

.block3 {
  height: 533px;
  background: url("src/assets/mobile/p_02.jpg");
  background-size: contain;
  background-position: center;
  /* background-repeat: no-repeat; */
  padding-top: 10px;
}
.b3-left {
  /* margin-top: 30px; */
}
.b3-text1 {
  margin-top: 8px;
  font-size: 14px;
  color: white;
}
.b3-img1 {
  text-align: center;
  display: block;
  margin: 39px auto 6px;
  width: 160px;
}
.b3-right {
  margin-top: 60px;
  width: 200px;
}

.block4 {
  height: 635px;
  background: linear-gradient(#f6f5f0, #5a5a5a);
  padding-top: 45px;
  position: relative;
}
.b4-left {
}
.b4-right {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.b4-con {
  margin-top: 22px;
}
.b4-con img {
  width: 50px;
  margin: 0px 8px;
  margin-bottom: 10px;
}
.b4-text1 {
  font-size: 26px;
  margin-bottom: -2px;
}
.b4-text2 {
  font-size: 18px;
}
.b4-text3 {
  font-size: 13px;
}

.block5 {
  height: 450px;
  margin-top: 40px;
}
.b5-text1 {
  font-size: 26px;
  color: white;
}
.b5-text2 {
  color: white;
  font-size: 10px;
  margin-bottom: 15px;
}
.b5-text3 {
  display: block;
  color: white;
  font-size: 20px;
}
.b5-text4 {
  display: block;
  color: white;
  font-size: 15px;
}
.b5-con1 {
  margin-top: 25px;
}
.b5-con2 {
  margin-top: 38px;
}
.b5-con3 {
  display: inline-block;
  margin: 0px 0px;
}
.b5-con3 img {
  height: 120px;
  margin-bottom: 7px;
}
.b5-con4 {
  margin-top: 20px;
}

.block6 {
  height: 1600px;
}
.b6-text1 {
  font-size: 24px;
  color: white;
}
.b6-text2 {
  font-size: 16px;
  color: white;
  margin-top: -7px;
}
.b6-text3 {
  font-size: 13px;
  color: white;
}
.b6-con1 {
  margin-top: 40px;
}
.b6-con2 {
  margin-bottom: 15px;
}
.b6-con2 img {
  width: 325px;
}
.b6-con3 {
  margin-top: 24px;
}
.b6-con3 div {
  line-height: 40px;
}
.b6-con4 {
  margin-top: 50px;
  margin-left: 92px;
}
.b6-con4 div {
  color: white;
  font-size: 16px;
  text-align: left;
}
.b6-text5 {
  font-size: 19px !important;
  margin-bottom: 8px;
  margin-top: 28px;
}

.block7 {
  /* height: 645px; */
  background-color: rgb(255, 255, 255);
  padding-top: 33px;
}
.b7-img0 {
  display: block;
  width: 125px;
  margin: 0px auto;
}
.b7-left {
  margin-bottom: 10px;
}
.b7-text1 {
  font-size: 23px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: black;
}
.b7-text2 {
  font-size: 14px;
  color: #666666;
  margin-top: 10px;
}
.b7-input {
  display: block;
  margin: auto;
  height: 45px;
  padding: 0px 5px;
  border: 0px;
  border-bottom: solid 1px #ec6841;
  color: #666;
  width: 300px;
  font-size: 16px;
  border-radius: 0px;
}
.b7-input:focus {
  outline: none;
}
.b7-btn {
  margin-top: 20px;
  border: none;
  width: 250px;
  height: 50px;
  border-radius: 44px;
  background: #ec6841;
  color: white;
  font-size: 20px;
}
.b7-btn:focus {
  outline: none;
}
.b7-btn:hover {
  background: #ec7f5d;
}
.b7-btn:active {
  background: #e65b31;
}
.b7-right {
  margin-top: 35px;
  background: rgb(242, 242, 242);
  padding-top: 26px;
  height: 200px;
}
.b7-img1 {
  display: block;
  width: 100px;
  margin: auto;
  margin-top: 13px;
}
.b7-text3 {
  font-size: 19px;
}
.b7-text4 {
  display: block;
  font-size: 16px;
  margin-top: 8px;
}
.b7-con2 {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: center;
  margin: 30px 50px;
}
.b7-img2 {
  width: 82px;
  margin-left: 50px;
}
.b7-con {
  width: 55%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.b7-text5 {
  font-size: 14px;
}
.qn_c {
  position: relative;
  width: fit-content;
  margin: 25px auto 0 auto;
}
.qn_link {
  width: 60%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 20%;
  z-index: 99;
}
.qn_item {
  width: 60%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.qnimg {
  width: 10%;
  margin-left: 10%;
}
.qnimg2 {
  width: 60%;
}
.questionnaire {
  width: 60%;
  margin-left: 5%;
  font-size: 23px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue